import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Button } from "reactstrap";
import { FormattedDate, FormattedTime } from "react-intl";

import { CircularProgress, TradeInlineDetail } from "../..";
import { localDateTime } from "../../../utils/Helper";

import style from "./TradeHistory.module.scss";

const TradeHistory = ({ trade, open, closeModalTradeHistory, dispatch, tradeId, onHistoryRequest }) => {
  const [histories, setHistories] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (tradeId && !histories) {
      onHistoryRequest({ tradeId }).then((response) => {
        setLoading(false);
        setHistories(response.response.histories);
      });
    }
  }, [tradeId]);

  const toggle = () => {
    dispatch(closeModalTradeHistory());
    setHistories(null);
    setLoading(true);
  };

  if (!open) {
    return null;
  }

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} className={style.modal}>
        <ModalHeader toggle={toggle}>
          Trade history
          <TradeInlineDetail trade={trade} />
        </ModalHeader>
        <ModalBody style={{ padding: "10px 2px" }}>
          <Container>
            <h5 className={style.subtitle}>History</h5>
            {loading ? (
              <CircularProgress />
            ) : (
              <div className={style.histories}>
                {histories &&
                  histories
                    .filter((item) => item.HistoryType != "Debug")
                    .map((item) => (
                      <div className={style.item} key={`h-${item.HistoryId}`}>
                        <div className={style.header}>
                          <span className={style.user}>{item.HistoryUserName}</span>

                          <span color="secondary" className={style.time}>
                            <FormattedDate value={localDateTime(item.HistoryDateTime)} />{" "}
                            <FormattedTime value={localDateTime(item.HistoryDateTime)} hour12={false} />
                          </span>
                        </div>

                        <p>{item.HistoryDetails.trim()}</p>
                      </div>
                    ))}
              </div>
            )}
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TradeHistory;
